import gsap from 'gsap'
import CustomEase from 'gsap/dist/CustomEase'
import Draggable from 'gsap/dist/Draggable'
import Flip from 'gsap/dist/Flip'
import InertiaPlugin from 'gsap/dist/InertiaPlugin'
import ScrollTrigger from 'gsap/dist/ScrollTrigger'
import SplitText from 'gsap/dist/SplitText'

if (typeof window !== 'undefined') {
  gsap.registerPlugin(CustomEase, Draggable, Flip, InertiaPlugin, ScrollTrigger, SplitText)
  CustomEase.create('inOut4', 'M0,0 C0.4,0 -0.06,1 1,1', { precision: 2 })
}
